import { combineReducers } from 'redux';
import { optimistic } from 'redux-optimistic-ui';
import cardListOrderReducer from './card-list-order/reducer';
import cardListReducer from './card-list/reducer';
import cardOrderGlobalReducer from './card-order-global/reducer';
import cardOrderReducer from './card-order/reducer';
import cardTypeReducer from './card-type/reducer';
import cardReducer from './card/reducer';
import columnReducer from './column/reducer';
import currentUserReducer from './current-user/reducer';
import { customFiltersReducer } from './custom-filters/reducer';
import estimationReducer from './estimation/reducer';
import inlineCreateReducer from './inline-create/reducer';
import issueParentsOrderReducer from './issue-parent-order/reducer';
import issueParentsReducer from './issue-parent/reducer';
import lastCreatedCardIdReducer from './last-created-card-id/reducer';
import prioritiesReducer from './priorities/reducer';
import projectReducer from './project/reducer';
import { trackingReducer } from './tracking/reducer';
import type { EntitiesState } from './types';
import versionReducer from './version/reducer';
import { versionsReducer } from './versions';

export default optimistic(
	combineReducers<EntitiesState>({
		card: cardReducer,
		cardList: cardListReducer,
		cardListOrder: cardListOrderReducer,
		cardOrder: cardOrderReducer,
		cardOrderGlobal: cardOrderGlobalReducer,
		column: columnReducer,
		currentUser: currentUserReducer,
		customFilters: customFiltersReducer,
		cardTypes: cardTypeReducer,
		estimation: estimationReducer,
		tracking: trackingReducer,
		inlineCreate: inlineCreateReducer,
		issueParents: issueParentsReducer,
		issueParentsOrder: issueParentsOrderReducer,
		priorities: prioritiesReducer,
		project: projectReducer,
		versions: versionsReducer,
		version: versionReducer,
		lastCreatedCardId: lastCreatedCardIdReducer,
	}),
);
